var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanToEarnGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4025_4796)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 70.6667,
    r: 57.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6965 94.0418H73.4703V88.8156H78.6965V94.0418ZM73.4703 75.7502H68.2441V88.8156H73.4703V75.7502ZM94.3751 70.524H89.1489V80.9764H94.3751V70.524ZM89.1489 65.2978H83.9227V70.524H89.1489V65.2978ZM57.7917 70.524H52.5655V75.7502H57.7917V70.524ZM52.5655 65.2978H47.3394V70.524H52.5655V65.2978ZM70.8572 52.2323H76.0834V47.0061H70.8572V52.2323ZM51.259 50.9257V58.765H59.0983V50.9257H51.259ZM60.4048 62.6847H49.9525C48.5152 62.6847 47.3394 61.5088 47.3394 60.0716V49.6192C47.3394 48.182 48.5152 47.0061 49.9525 47.0061H60.4048C61.842 47.0061 63.0179 48.182 63.0179 49.6192V60.0716C63.0179 61.5088 61.842 62.6847 60.4048 62.6847ZM51.259 82.2829V90.1222H59.0983V82.2829H51.259ZM60.4048 94.0418H49.9525C48.5152 94.0418 47.3394 92.8659 47.3394 91.4287V80.9764C47.3394 79.5391 48.5152 78.3633 49.9525 78.3633H60.4048C61.842 78.3633 63.0179 79.5391 63.0179 80.9764V91.4287C63.0179 92.8659 61.842 94.0418 60.4048 94.0418ZM82.6161 50.9257V58.765H90.4554V50.9257H82.6161ZM91.762 62.6847H81.3096C79.8724 62.6847 78.6965 61.5088 78.6965 60.0716V49.6192C78.6965 48.182 79.8724 47.0061 81.3096 47.0061H91.762C93.1992 47.0061 94.3751 48.182 94.3751 49.6192V60.0716C94.3751 61.5088 93.1992 62.6847 91.762 62.6847ZM89.1489 88.8156V80.9764H78.6965V86.2025H83.9227V94.0418H94.3751V88.8156H89.1489ZM83.9227 70.524H73.4703V75.7502H83.9227V70.524ZM73.4703 65.2978H57.7917V70.524H63.0179V75.7502H68.2441V70.524H73.4703V65.2978ZM76.0834 62.6847V57.4585H70.8572V52.2323H65.631V62.6847H76.0834ZM57.1385 52.8856H53.2188V56.8052H57.1385V52.8856ZM57.1385 84.2427H53.2188V88.1624H57.1385V84.2427ZM88.4956 52.8856H84.576V56.8052H88.4956V52.8856Z",
    fill: "#006DB7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4025_4796",
    x: 0.5,
    y: 0.166748,
    width: 141,
    height: 141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.633333 0 0 0 0 0.633333 0 0 0 0 0.633333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4025_4796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4025_4796",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanToEarnGuest);
export default __webpack_public_path__ + "static/media/ScanToEarnGuest.f6f219979715295851f441820689d833.svg";
export { ForwardRef as ReactComponent };